import type { FaireProductEntity } from "../../entity_types/product";

export const p_kcr4e5zzjx: FaireProductEntity = {
  token: "p_kcr4e5zzjx",
  type: "product",
  name: "Crystal Quartz Buddha Mini Statue - By Weight (RK24)",
  brandToken: "b_de8f5way8k",
  brandName: "Rock Paradise",
  imageUrl:
    "https://cdn.faire.com/fastly/883c0e95a0b92592c54d95f0f910635397de15b61da581c5075ef4884eee62b0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/692c5a998287ce70428667d7c23b8ba93d9da4109c30821993bcb6aa907e6ca1.jpeg",
    "https://cdn.faire.com/fastly/a190b7fc53f1308333b2546bf90a4f6ac2fa741b04e94ffa021b0e9d14ce919a.jpeg",
    "https://cdn.faire.com/fastly/e7d770466f80d8a12420cf7ea6f8ca3de0432635905b1fb7b5dccc70970e275a.jpeg",
    "https://cdn.faire.com/fastly/a1e9feab6704017a62dbac53260d34f9832807cd2a8b925a96ac873364c337f9.jpeg",
    "https://cdn.faire.com/fastly/d33958e8b2d0d940bb34556182aee1f34a19326a94e90d748c17dc60f1ff46cc.jpeg",
  ],
  priceDollars: 29.1,
  description:
    "This listing is for ONE (1) Crystal Quartz Polished Buddha Mini Statue (RK24)\n\nSTOCK PHOTO - These mini-statues may range in size and characteristics due to them being natural.\n\nMeasurements will range as sizing gets higher. Some points may be small but thick, or tall but thin, etc..\n\nWEIGHTS AVAILABLE ARE: \n- Up to 200g\n- Up to 300g\n- Up to 400g\n\n**You can choose your desired weight! Just use the option menu to select your option.**\n\nThese are amazing quality, perfect for your home or office decor, crafts, keeping in your meditation space, or even gifting!\n\nThank you for looking, have an amazing day.",
  tags: [],
  msrpDollars: 58.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:46.863Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
